/**
 * 播放相关 API
 * 参考 tv-linux 项目的接口实现
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

// 类型定义已迁移到 src/pages/playDetail/types.ts
import type { PlayUrlResponse, PlayListResponse, PlayHistoryResponse } from '../pages/playDetail/types';

/**
 * 获取播放详情页面展示内容
 * @param cid 内容 ID（必填）
 * @param vid 视频 ID（可选）；不传时接口返回默认/首集信息，可从 video_data.current_video_data.vid 取 vid
 */
export async function getPlayUrl(
  cid: string,
  vid?: string,
  vipInfo?: { is_vip: boolean }
): Promise<ApiResponse<PlayUrlResponse['data']>> {
  return post<PlayUrlResponse['data']>(API_PATHS.getDetail, {
    cid,
    ...(vid !== undefined && vid !== null && vid !== '' && { vid }),
    user_vip_info: vipInfo,
  });
}

/**
 * 获取播放详情页面剧集分页列表内容
 */
export async function getPlayList(
  dataKey: string,
  pageContext: string | null
): Promise<ApiResponse<PlayListResponse['data']>> {
  return post<PlayListResponse['data']>(API_PATHS.getDetailPage, {
    data_key: dataKey,
    page_context: pageContext,
  });
}

/**
 * 获取播放历史记录
 */
export async function getPlayHistory(cid: string, vid?: string): Promise<ApiResponse<PlayHistoryResponse['data']>> {
  return post<PlayHistoryResponse['data']>(API_PATHS.lastPlay, {
    cid,
    vid,
  });
}

/**
 * 上报播放历史
 */
export async function reportPlayHistory(params: {
  cid: string;
  vid: string;
  playTime: number;
  totalTime: number;
}): Promise<void> {
  await post(API_PATHS.historyReport, params);
}
